import styled from 'styled-components'

export const FormWrapper = styled.div`
  width: 600px;
  max-width: 100%;
  padding: 1rem;
  margin: 0 auto;
`

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  text-align: center;
  max-height: 100%;
  height: 100%;
`

export const IconWrapper = styled.div`
  color: ${({ theme }) => theme.colors.danger};
  margin-bottom: 0.5rem;
`

export const ErrorTitle = styled.h3`
  color: ${({ theme }) => theme.colors.danger};
  font-weight: 600;
  font-size: 1.25rem;
  margin: 0;
`

export const ErrorMessage = styled.p`
  color: #1f1f1f;
  font-size: 0.875rem;
  margin: 0;
  text-align: center;
  line-height: 1.5;
  font-weight: 500;
  line-height: 1.25rem;
`

export const Section = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  text-align: left;
  margin-top: 1.5rem;
`

export const SectionTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  font-size: 0.9375rem;
  color: ${({ theme }) => theme.colors.neutral.low.pure};
`

export const SectionIcon = styled.div<{ color: 'danger' | 'success' }>`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme, color }) =>
    color === 'danger' ? theme.colors.danger : theme.colors.success};
  font-size: 1rem;
`

export const TagList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`

export const Tag = styled.span<{ variant: 'danger' | 'success' }>`
  display: inline-flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 500;
  background-color: ${({ variant }) =>
    variant === 'danger' ? '#FFDFD9' : '#AFF79E'};
  color: #1f1f1f;
`

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  margin-top: 0.5rem;
`

export const ErrorPre = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.neutral.high.lightest};
  border: 1px solid ${({ theme }) => theme.colors.neutral.high.medium};
  border-radius: 4px;
  padding: 1rem;
  overflow-x: auto;
  text-align: left;

  pre {
    margin: 0;
    font-family: 'Courier New', monospace;
    font-size: 0.875rem;
    color: ${({ theme }) => theme.colors.danger};
    white-space: pre-wrap;
    word-wrap: break-word;
  }
`

export const ErrorListContainer = styled.div`
  width: 100%;
  text-align: left;
  flex: 1;
  overflow: auto;
`

export const AlertSection = styled.div`
  width: 100%;
  text-align: left;
`

export const FormDataContainer = styled.div`
  font-size: 0.875rem;
  padding: 1rem;
  background-color: var(--sl-bg-neutral-light);
  border: 1px solid var(--sl-border-neutral);
  border-radius: 4px;
`

export const FormDataTitle = styled.div`
  font-weight: 600;
  margin-bottom: 0.75rem;
`

export const FormDataItem = styled.div`
  margin-bottom: 0.5rem;

  &:last-child {
    margin-bottom: 0;
  }
`

export const FormDataLabel = styled.strong`
  font-weight: 700;
`

export const ErrorItemWrapper = styled.div`
  margin-bottom: 1rem;
`

export const AlertContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 100%;
`

export const ErrorCode = styled.div`
  font-weight: 600;
  width: 100%;
`

export const ErrorField = styled.div`
  font-size: 0.875rem;
`

export const ErrorFieldLabel = styled.strong`
  font-weight: 700;
`

export const ErrorDetail = styled.div`
  font-size: 0.875rem;
  padding-left: 1rem;
`

export const ErrorDetailLabel = styled.strong`
  font-weight: 700;
`

// BaseError styles
export const BaseErrorContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 100%;
`

export const BaseErrorHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
`

export const BaseErrorLinesBadge = styled.span`
  font-size: 0.875rem;
  font-weight: 500;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const BaseErrorField = styled.div`
  font-size: 0.875rem;
`

export const BaseErrorFieldLabel = styled.strong`
  font-weight: 600;
`

// InternalError styles
export const InternalErrorMessage = styled.div`
  font-weight: 600;
`

export const InternalErrorDetails = styled.div`
  font-size: 0.875rem;
  padding-left: 1rem;
`
